<app-loader></app-loader>
<router-outlet></router-outlet>
<app-minimized-meeting-indicator *ngIf="!isWorkflowTaskRoute"></app-minimized-meeting-indicator>
